import type { Messages } from './en.js';

export const fr: Messages = {
  'app.title': 'Sync Port · transfert de fichiers P2P',
  'secure.badge': 'Chiffré de bout en bout · d’appareil à appareil · rien n’est stocké sur un serveur',
  'secure.tooltip':
    'Les canaux de données WebRTC sont chiffrés en DTLS entre les deux appareils. Le serveur et le relais TURN ne voient que des données chiffrées.',
  'error.title': 'Transmission perdue',
  'error.peerFailed': 'La connexion directe a échoué. Vérifiez le réseau ou la configuration du relais TURN.',
  'error.signaling': 'Impossible de joindre le serveur de signalisation.',
  'error.roomNotFound': 'Aucun transfert ouvert ne correspond à ce lien ou à ce code PIN. L’expéditeur a peut-être fermé la page, ou le code est mal saisi.',
  'error.roomFull': 'Quelqu’un d’autre a déjà ouvert ce lien. Chaque lien ne fonctionne que pour un seul destinataire.',
  'notFound.tagline': 'À cette coordonnée, il n’y a que du vide.',
  'notFound.text': 'La page que vous avez ouverte n’existe pas.',
  'notFound.action': 'Envoyer un fichier',
  'action.startOver': 'Recommencer',
  'action.retry': 'Réessayer',
  'action.cancel': 'Annuler',
  'action.dismiss': 'Fermer',
  'sender.tagline': 'Envoyez des fichiers entre appareils par un lien privé et chiffré. Rien ne reste en orbite.',
  'drop.title': 'Choisissez un fichier à envoyer',
  'drop.hint': 'Touchez ou déposez un fichier ici · toutes tailles',
  'share.title': 'Partagez ce lien',
  'share.text': 'Ouvrez-le sur l’autre appareil ou scannez le code avec l’appareil photo d’un téléphone.',
  'share.linkLabel': 'Lien de partage',
  'share.copy': 'Copier le lien',
  'share.native': 'Partager…',
  'share.or': 'ou',
  'share.pinHint': 'Saisissez ce code PIN sur la page d’accueil de l’autre appareil.',
  'share.pinLabel': 'Code PIN du transfert',
  'share.copied': 'Copié dans le presse-papiers',
  'share.shared': 'Partagé',
  'share.linkMessage': 'Ouvrez ce lien pour recevoir un fichier de ma part :',
  'share.unavailable': 'Ce navigateur n’a pas de menu de partage système.',
  'clipboard.blocked': 'Le navigateur bloque la copie. Sélectionnez le lien et copiez-le manuellement.',
  'pin.title': 'Vous avez un code PIN ou un QR code ?',
  'pin.text': 'Saisissez le code à 9 chiffres affiché sur l’appareil expéditeur, ou scannez son QR code.',
  'pin.receive': 'Recevoir',
  'pin.scan': '📷 Scanner le QR code',
  'pin.incomplete': 'Saisissez les {count} chiffres du code PIN.',
  'scan.hint': 'Pointez la caméra vers le QR code de l’appareil expéditeur',
  'scan.notOurs': 'Ce code n’est pas un lien Sync Port. Cherchez celui affiché sur l’appareil expéditeur.',
  'camera.denied': 'L’accès à la caméra a été refusé. Autorisez-le dans les réglages du navigateur, ou saisissez le code PIN.',
  'camera.notFound': 'Aucune caméra n’a été trouvée sur cet appareil.',
  'camera.busy': 'La caméra est utilisée par une autre application.',
  'camera.failed': 'Impossible d’ouvrir la caméra ({reason}).',
  'sender.status.creatingRoom': 'Création d’un salon privé',
  'sender.status.waitingReceiver': 'En attente de l’ouverture du lien par le destinataire',
  'sender.status.receiverConnected': 'Destinataire connecté, ouverture d’un canal direct chiffré',
  'sender.status.waitingDestination': 'Canal chiffré ouvert. En attente du choix de l’emplacement par le destinataire',
  'sender.status.beaming': 'Envoi du fichier à travers l’espace',
  'sender.status.delivered': 'Livré',
  'status.failed': 'Le transfert a échoué',
  'progress.sending': 'Envoi',
  'progress.receiving': 'Réception',
  'progress.sentDetail': 'Envoyé {sent} · confirmé par le destinataire {acked}',
  'progress.deliveredDetail': 'Le destinataire a reçu le fichier complet.',
  'progress.arrivedDetail': 'Chaque octet est arrivé.',
  'progress.of': '{done} sur {total}',
  'progress.speedEta': '{speed} · reste {eta}',
  'route.finding': 'Recherche du meilleur itinéraire',
  'route.direct': 'Connexion directe',
  'route.nat': 'Connexion directe à travers le NAT',
  'route.relay': 'Relayé par TURN',
  'route.relayOver': 'Relayé par TURN en {protocol}',
  'sender.sendAnother': 'Envoyer un autre fichier',
  'receiver.tagline': 'Transmission entrante par un lien privé et chiffré. Gardez cette page ouverte jusqu’à l’arrivée du fichier.',
  'receiver.status.contacting': 'Contact de l’expéditeur',
  'receiver.status.connected': 'Connecté à l’expéditeur, ouverture d’un canal direct chiffré',
  'receiver.status.channelOpen': 'Canal chiffré ouvert, en attente des détails du fichier',
  'receiver.status.chooseDestination': 'Choisissez où enregistrer pour commencer la réception',
  'receiver.status.receiving': 'Réception',
  'receiver.status.complete': 'Terminé',
  'dest.title': 'Prêt à recevoir',
  'dest.picker.button': 'Choisir où enregistrer',
  'dest.picker.text': '{size} en approche. Choisissez une destination : le fichier y sera écrit directement.',
  'dest.worker.button': 'Enregistrer sur cet appareil',
  'dest.worker.text': '{size} en approche. Le fichier sera écrit directement dans votre dossier Téléchargements au fil de la réception.',
  'dest.memory.button': 'Recevoir le fichier',
  'dest.memory.text': '{size} en approche. Ce navigateur le garde dans l’onglet jusqu’à ce que vous l’enregistriez ensuite.',
  'dest.cancelled': 'Choisissez une destination pour commencer la réception.',
  'landed.title': 'Bien arrivé',
  'landed.chosenFolder': 'Enregistré sous {name} dans le dossier choisi.',
  'landed.downloads': 'Enregistré dans le dossier Téléchargements du navigateur.',
  'landed.openWith': 'Ouvrir avec…',
  'landed.sendYourself': 'Envoyer un fichier à votre tour',
  'memory.received': '{size} reçus. Enregistrez le fichier sur cet appareil.',
  'memory.save': 'Enregistrer le fichier',
  'memory.saved': 'Enregistré dans le dossier Téléchargements du navigateur. Vous pouvez aussi l’ouvrir tout de suite dans une autre application.',
  'memory.saveAgain': 'Enregistrer à nouveau',
  'error.inboxNotFound': 'Ce numéro de boîte n’existe pas.',
  'error.inboxUnauthorized': 'La clé ne correspond pas à cette boîte.',
  'error.declined': 'Le propriétaire de la boîte a refusé ce fichier.',
  'error.inboxLimit': 'Impossible de créer d’autres boîtes sur ce serveur.',
  'home.inboxLink': 'Créer une boîte',
  'inbox.tagline': 'Votre boîte permanente. Quiconque scanne le code peut vous proposer un fichier ; vous décidez ce que vous recevez.',
  'inbox.create.title': 'Créer une boîte',
  'inbox.create.text': 'Obtenez un numéro permanent et un QR code. Quiconque le scanne peut vous proposer un fichier ; rien n’arrive tant que vous n’acceptez pas.',
  'inbox.create.button': 'Créer ma boîte',
  'inbox.connect.title': 'Vous avez déjà une boîte ?',
  'inbox.connect.text': 'Collez la clé secrète pour utiliser la boîte sur cet appareil. Le numéro est facultatif : il peut être retrouvé à partir de la clé.',
  'inbox.connect.numberOptional': 'Numéro de la boîte (facultatif)',
  'error.keyUnknown': 'Aucune boîte ne correspond à cette clé.',
  'inbox.connect.number': 'Numéro de la boîte',
  'inbox.connect.key': 'Clé secrète',
  'inbox.connect.button': 'Connecter',
  'inbox.key.title': 'Votre clé secrète',
  'inbox.key.text': 'Conservez le numéro et la clé ensemble, en lieu sûr. La clé n’est affichée qu’ici et, avec le numéro, c’est le seul moyen d’ouvrir cette boîte sur un autre appareil.',
  'inbox.key.copy': 'Copier le numéro et la clé',
  'inbox.key.copied': 'Numéro et clé copiés',
  'inbox.key.done': 'Je les ai enregistrés',
  'inbox.number.title': 'Numéro de votre boîte',
  'inbox.number.text': 'Imprimez ce code ou affichez-le sur un écran. Les clients le scannent ou saisissent le numéro sur la page d’accueil.',
  'inbox.status.connecting': 'Connexion à votre boîte',
  'inbox.status.online': 'En ligne. En attente de clients',
  'inbox.status.reconnecting': 'Connexion perdue. Reconnexion',
  'inbox.requests.title': 'Demandes entrantes',
  'inbox.requests.empty': 'Aucune demande pour l’instant. Elles apparaîtront ici dès qu’un client enverra un fichier.',
  'inbox.request.accept': 'Accepter et enregistrer…',
  'inbox.request.decline': 'Refuser',
  'inbox.request.connecting': 'Accepté. Connexion au client',
  'inbox.request.cancelled': 'Le client est parti avant votre réponse.',
  'inbox.refresh': 'Actualiser',
  'inbox.forget': 'Oublier cette boîte sur cet appareil',
  'toInbox.tagline': 'Envoyer un fichier à la boîte {number}. Le propriétaire voit votre demande et décide.',
  'toInbox.status.announcing': 'Annonce de votre fichier à la boîte',
  'toInbox.status.waitingOnline': 'Transmis à la boîte. En attente d’approbation',
  'toInbox.status.waitingOffline': 'Le propriétaire de la boîte n’est pas en ligne pour le moment. Votre demande attendra son retour',
  'toInbox.status.accepted': 'Accepté. Ouverture d’un canal direct chiffré',
  'inbox.print': 'Imprimer l’affiche (PDF)',
  'poster.title': 'Envoyez-moi vos fichiers',
  'poster.number': 'Numéro de la boîte',
  'poster.step1': 'Scannez le code avec l’appareil photo de votre téléphone.',
  'poster.step2': 'Ou ouvrez {link} et saisissez le numéro.',
  'poster.step3': 'Choisissez le fichier. Nous l’acceptons ici même, au comptoir.',
  'poster.footer': 'Sync Port · chiffré de bout en bout, d’appareil à appareil. Rien n’est stocké sur un serveur.',
  'install.title': 'Installer Sync Port',
  'install.native': 'Ajoutez-la à votre écran d’accueil pour un accès rapide.',
  'install.ios': 'Touchez « Partager », puis « Sur l’écran d’accueil ».',
  'install.button': 'Installer',
};
